import { Component, OnInit } from '@angular/core';
import { Column } from 'exceljs';
import { PlayerListColumn } from '../shared/player-list/player-list-column';
import { CocaColaHccbService } from './coca-cola-hccb.service';

@Component({
  selector: 'app-coca-cola-values-game-hccb',
  templateUrl: './coca-cola-values-game-hccb.component.html',
})
export class CocaColaValuesGameHccbComponent implements OnInit {
  currentTab = 'Scientific Rigour';
  scientificRigourColumns: PlayerListColumn[] = [
    {
      name: 'Learner Id',
      key: 'learnerId',
    },
    {
      name: 'Name',
      key: 'name',
    },
    {
      name: 'Innovation',
      key: 'Innovation',
    },
    {
      name: 'Net Revenue',
      key: 'NetRevenue',
    },
    {
      name: 'Stakeholder Engagement',
      key: 'StakeholderEngagement',
    },
    {
      name: 'Total Score',
      key: 'totalScore',
    },
  ];
  scientificRigourPlayers$ = this._cocaColaHCCBService.scientificRigourPlayers$;

  scientificRigourWorksheetColumns = [
    { header: 'Rank', key: 'rank', width: 20 } as Column,
    { header: 'Name', key: 'name', width: 40 } as Column,
    { header: 'Innovation', key: 'Innovation', width: 40 } as Column,
    { header: 'Net Revenue', key: 'NetRevenue', width: 40 } as Column,
    {
      header: 'Stakeholder Engagement',
      key: 'StakeholderEngagement',
      width: 40,
    } as Column,
    { header: 'Total Score', key: 'totalScore', width: 40 } as Column,
  ];

  constructor(private _cocaColaHCCBService: CocaColaHccbService) {
    this._cocaColaHCCBService.fetchPlayersData();
  }

  ngOnInit(): void {
    console.log('Loaded');
  }

  tabChanged(event: any): void {
    console.log('Event: ', event);
  }
}
